<script setup>
import HeaderNav from "@components/HeaderNav.vue";
import SectionHero from "@sections/SectionHero.vue";
import SectionWhy from "@sections/SectionWhy.vue";
import SectionFollowUs from "@sections/SectionFollowUs.vue";
import SectionFooter from "@sections/SectionFooter.vue";
</script>

<template>
    <div class="bg-black overflow-x-hidden">
        <HeaderNav />
        <SectionHero />
        <SectionWhy />
        <SectionFollowUs />
        <SectionFooter />
    </div>
</template>
